import { useState, useEffect } from "react";
import axios from "axios";

const statusColor = {
  Pending: "#0DCAF0",
  Requested: "#F19C00",
  Rejected: "#DC3545",
  Completed: "#20BF44",
};

const PAGE_SIZE = 10;

export default function RequestList() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const baseAPI = process.env.REACT_APP_API_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const headers = {
    Authorization: `Bearer ${storedToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await axios.get(
          `${baseAPI}userGet/GetPettyCashDetail?pettycash_id=0&relocation_id=0`,
          { headers }
        );
        setRequests(res.data.data || []);
      } catch (err) {
        console.error("Error fetching petty cash list:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchList();
  }, []);

  const totalPages = Math.ceil(requests.length / PAGE_SIZE);
  const paginatedRequests = requests.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  if (loading) {
    return (
      <div style={{ padding: 14, textAlign: "center", color: "#888", fontSize: 13 }}>
        Loading...
      </div>
    );
  }

  return (
    <div style={{ padding: 14, background: "#f7f7f7" }}>

      {/* Section header */}
      <div style={{ background: "#534AB7", borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
        <span style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>Request List</span>
      </div>

      {requests.length === 0 ? (
        <div style={{ textAlign: "center", color: "#888", fontSize: 13, padding: 20 }}>
          No requests found.
        </div>
      ) : (
        <>
          {paginatedRequests.map((item, idx) => (
            <div key={item.pettycash_id} style={{
              background: "#fff",
              border: "0.5px solid #e0d8f5",
              borderRadius: 10,
              padding: 14,
              marginBottom: 12,
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontSize: 12, color: "#555" }}>
                  S No. : <strong>{String((currentPage - 1) * PAGE_SIZE + idx + 1).padStart(2, "0")}</strong>
                </span>
                {item.relocation_id ? (
                  <span style={{ fontSize: 12, color: "#e05c8a", fontWeight: 500 }}>
                    LEAD ID : {item.relocation_id}
                  </span>
                ) : null}
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <span style={{ fontSize: 16, fontWeight: 500, color: "#534AB7" }}>
                  ₹ {Number(item.amount).toLocaleString("en-IN")}
                </span>
                <span style={{ fontSize: 12, fontWeight: 500, color: statusColor[item.approval_status] || "#888" }}>
                  {item.approval_status}
                </span>
              </div>

              <div style={{ borderTop: "0.5px solid #eee", paddingTop: 8, display: "flex", flexDirection: "column", gap: 5 }}>
                {[
                  { label: "Receipt No",   value: item.pettycash_id },
                  { label: "Request Type", value: item.request_type_name },
                  { label: "Requested By", value: item.requested_by_name },
                  { label: "Request Date", value: item.request_date },
                  { label: "Remark",       value: item.remark || "—" },
                ].map(({ label, value }) => (
                  <div key={label} style={{ display: "flex", gap: 6, fontSize: 12 }}>
                    <span style={{ color: "#888", width: 90, flexShrink: 0 }}>{label}</span>
                    <span style={{ color: "#555", flex: 1 }}>: {value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Pagination */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
            <span style={{ fontSize: 12, color: "#888" }}>
              Page {currentPage} of {totalPages}
            </span>
            <div style={{ display: "flex", gap: 6 }}>
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px 14px", fontSize: 12, borderRadius: 6, border: "0.5px solid #d0c8f0",
                  background: currentPage === 1 ? "#f0eeff" : "#534AB7",
                  color: currentPage === 1 ? "#aaa" : "#fff",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Prev
              </button>
              <button
                onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px 14px", fontSize: 12, borderRadius: 6, border: "0.5px solid #d0c8f0",
                  background: currentPage === totalPages ? "#f0eeff" : "#534AB7",
                  color: currentPage === totalPages ? "#aaa" : "#fff",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}